module.exports = __webpack_public_path__ + "img/seller_amend posting additional categories.17593658.svg";